import styled from "styled-components";
import { theme } from "../../styles/theme";

export const LoadingContainer = styled.div`
    width: 100%;
    height: 90dvh;

    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 760) {
        width: 100%;
    }
`

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 16px 32px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 760px) {
        padding: 16px;
    }
`;

export const ContainerInputsAndFilter = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    >div:nth-of-type(1), 
    >div:nth-of-type(2) {
        max-width: 220px;
        height: auto !important;
    }

    @media (max-width: 1024px) {
        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 300px;
        }
    }

    @media (max-width: 760px) {
        gap: 8px;

        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 160px;
        }
    }

      @media (max-width: 360px) {
        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 80%;
        }
    }
`;

export const ButtonShowAll = styled.button`
    all: unset;
    height: auto;
    width: 6.6875rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    margin: 20px auto;

    > p {
        cursor: pointer;
        text-align: center;
    }

    > img {
        width: 1rem;
        height: auto;
    }
`;

export const ViewPayloadButton = styled.button`
    all: unset;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid ${theme.colors.gray.Cinza_10};
    color: ${theme.colors.gray.Cinza_1};
    font-family: "Lato";
    font-size: 12px;
    font-weight: 700;
    line-height: 1;

    :hover {
        opacity: 0.8;
    }
`;

export const PayloadPre = styled.pre`
    width: 100%;
    max-height: 52vh;
    margin: 0;
    padding: 0 12px 12px;
    overflow: auto;
    border-radius: 0;
    border: none;
    background: transparent;
    text-align: left;
    font-size: 12px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-break: break-word;
    color: #ffffff;
`;

export const HelpLink = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin-top: 8px;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.blue.Azul_link};

    img {
        width: 14px;
        height: 14px;
    }
`;

export const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    width: 100%;
    max-width: 1200px;
    margin: 16px auto;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const Card = styled.div`
    background-color: #F8F8F9;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

export const CardHeaderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const CardBadge = styled.span`
    flex-shrink: 0;
    padding: 4px 10px;
    border-radius: 20px;
    font-family: Lato;
    font-size: 11px;
    font-weight: 800;
    white-space: nowrap;
    background-color: ${({ variant }) => (
      variant === "relatorio" || variant === "automatico" ? theme.colors.blue.fundo :
      theme.colors.gray.fundo
    )};
    color: ${({ variant }) => (
      variant === "relatorio" || variant === "automatico" ? theme.colors.blue.Azul_link :
      theme.colors.gray.Cinza_7
    )};
`;

export const PendingBadge = styled.span`
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 4px 10px;
    border-radius: 20px;
    font-family: Lato;
    font-size: 11px;
    font-weight: 800;
    color: ${theme.colors.red.Vermelho_erro};
    background-color: ${theme.colors.red.fundo};

    img {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
    }
`;

export const CardFlag = styled.img`
    width: 34px;
    height: 26px;
    
    border-radius: 4px;
    border: 1px solid #DFE4EB;
    object-fit: cover;
    flex-shrink: 0;
`;

export const CardFlagFallback = styled.div`
    width: 34px;
    height: 26px;
    border-radius: 4px;
    border: 1px solid #DFE4EB;
    background-color: ${theme.colors.green.Verde_AgroReceita};
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Lato;
    font-size: 10px;
    font-weight: 800;
    flex-shrink: 0;
`;

export const CardTitle = styled.p`
    font-family: Lato;
    font-size: 0.6875rem;
    font-weight: 800;
    line-height: 1.0313rem;
    letter-spacing: 0.1em;
    color: #303848;
    text-transform: uppercase;
    margin: 0;
`;

export const CardOrgao = styled.p`
    font-family: Lato;
    font-size: 16px;
    font-weight: 800;
    color: ${theme.colors.gray.Cinza_1};
    margin: 0;
`;

export const CardDescription = styled.p`
    font-family: Lato;
    font-size: 13px;
    font-weight: 400;
    color: ${theme.colors.gray.Cinza_2};
    line-height: 1.4;
    margin: 0;
    flex-grow: 1;

    strong, b {
        font-weight: 800;
    }
`;

export const CardActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: auto;
`;

export const MtSubCard = styled.div`
    background-color: #FFF;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MtSubHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

export const MtSubTitle = styled.p`
    font-family: Lato;
    font-size: 14px;
    font-weight: 800;
    color: ${theme.colors.gray.Cinza_2};
    margin: 0;
`;

export const CardManualLink = styled.a`
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.blue.Azul_link};
    text-decoration: none;

    img {
        width: 14px;
        height: 14px;
    }

    &:hover {
        text-decoration: underline;
    }
`;

export const PayloadFrame = styled.div`
    width: 100%;
    margin-top: 16px;
    background-color: rgb(40, 42, 54);
    color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
`;

export const PayloadCopyRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 8px;
    cursor: pointer;

    > img {
        width: 24px;
        transition: all 0.3s ease;
    }

    > img:hover {
        transform: scale(1.1);
    }

    > img:active {
        transform: scale(0.95);
    }
`;

// Busca e toggle dividem a mesma linha; no mobile o toggle quebra pra baixo.
export const SearchRow = styled.div`
    width: 100%;
    margin: 20px 0 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 24px;
`;

export const SearchField = styled.div`
    width: 100%;
    max-width: 480px;
`;

export const ToggleRow = styled.div`
    width: auto;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    cursor: pointer;
    user-select: none;

    > p {
        margin: 0;
    }
`;

export const ToggleHelpIcon = styled.button`
    all: unset;
    box-sizing: border-box;

    width: 20px;
    height: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    > svg {
        width: 18px;
        height: 18px;
    }
`;
